<template>
  <q-dialog
    :value="value"
    no-backdrop-dismiss
    @input="$emit('input', $event)"
  >
    <span slot="title">
      <slot name="title" />
    </span>
    <span slot="message">
      <slot name="message" />
    </span>
    <div slot="body">
      <q-field
        :data-test="CypressTarget('NameField')"
        :error="$v.chairHolderName.$error"
        :error-label="$t('error.required.field', {field: $t('field.user.name.label')})"
        :helper="$t('label.required')"
        :count="maxSeatCharacters"
      >
        <q-input
          v-model.trim="chairHolderName"
          :data-test="CypressTarget('Input')"
          :color="SET_COLOR.primary"
          :float-label="$t('field.user.name.label')"
          :maxlength="maxSeatCharacters"
          type="text"
          required
          autofocus
          autocomplete="name"
          @blur="$v.chairHolderName.$touch()"
        />
      </q-field>
    </div>
    <template
      slot="buttons"
      slot-scope="props"
      :data-test="CypressTarget('Buttons')"
    >
      <q-btn
        :label="$t('button.cancel')"
        :data-test="CypressTarget('Cancel')"
        :color="SET_COLOR.buttons.cancel || 'dark'"
        flat
        sparse
        @click="$emit('input', false)"
      />
      <q-btn
        :label="$t('button.rename')"
        :data-test="CypressTarget('Ok')"
        :color="SET_COLOR.buttons.ok || 'dark'"
        flat
        sparse
        @click="$emit('changeName', chairHolderName)"
      />
    </template>
  </q-dialog>
</template>

<script>
  import ModalSeatNameMixin from 'mixins/components/modal/seat/seatName';

  export default {
    name: 'ModalNameTypePopUp',
    mixins: [ModalSeatNameMixin],
    props: {
      value: {
        type: Boolean,
        required: false,
        default: false,
      },
      chairHolder: {
        type: String,
        required: true,
        default: '',
      },
      maxSeatCharacters: {
        type: Number,
        required: false,
        default: 20,
      },
    },
  };
</script>
